import Chart from 'chart.js/auto';
// Force an integer device pixel ratio so Chart.js canvas-drawn text
// (tooltips, chartjs-plugin-annotation labels), lines and gridlines stay
// crisp. A fractional window.devicePixelRatio (e.g. Windows display scaling
// at 125%/150% -> 1.25/1.5) makes the dpr-scaled canvas render text at
// sub-pixel positions, which looks blurry. Snapping up to the next integer
// with a floor of 2 keeps the backing store -> device pixel mapping ~1:1
// and also crisps text on plain 1x monitors. Charts use animation: false,
// so the extra redraw cost is negligible.
if (typeof window !== 'undefined') {
    Chart.defaults.devicePixelRatio = Math.max(2, Math.ceil(window.devicePixelRatio || 1));
}
